import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useRole } from '../../hooks/useRole';
import PayrollUpload from '../../components/Payslips/PayrollUpload';
import { createPayrollTemplate } from '../../utils/createExcelTemplate';

const PayrollPage: FC = () => {
  const { isAdmin, loading } = useRole();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  const handleDownloadTemplate = () => {
    try {
      const buffer = createPayrollTemplate();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'payroll-template.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error creating template:', error);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Payroll Management</h1>
        <p className="mt-2 text-sm text-gray-600">
          Upload payroll data to generate employee payslips
        </p>
      </div>

      <div className="bg-white rounded-lg shadow">
        <PayrollUpload />
      </div>

      <div className="mt-8 bg-blue-50 border border-blue-200 rounded-md p-4">
        <h2 className="text-lg font-medium text-blue-800 mb-2">Excel Template Format</h2>
        <p className="text-sm text-blue-600 mb-4">
          Please ensure your Excel file follows this format:
        </p>
        <ul className="list-disc list-inside text-sm text-blue-600 space-y-1">
          <li>First row: Period (e.g., "January 16-31, 2025")</li>
          <li>Required columns: Employee, Daily Rate, Total Hours, etc.</li>
          <li>Employee names must match their display names in the system</li>
        </ul>
        <div className="mt-4">
          <button
            onClick={handleDownloadTemplate}
            className="inline-flex items-center px-4 py-2 border border-blue-600 text-sm font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50"
          >
            Download Template
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayrollPage; 